module.exports = __webpack_public_path__ + "static/media/Mask_group.e52cd8e7.png";